module.exports = __webpack_public_path__ + "img/map-tr-small-orange.519aa348.svg";